'use strict';

exports.__esModule = true;
/* eslint-disable import/prefer-default-export */
var translation = exports.translation = {
  en: {
    somethingWentWrong: 'Something went wrong !',
    tryAgain: 'Try again',
    print: 'Print',
    invoice: 'Invoice',
    details: 'Details',
    invoiceNo: 'Invoice number:',
    date: 'Date:',
    billTo: 'Bill to',
    description: 'Description',
    qty: 'Qty',
    price: 'Price',
    insuranceCoverage: 'Ins. Coverage',
    amount: 'Amount',
    subTotal: 'Sub total',
    discount: 'Discount',
    vat: 'VAT (14%)',
    total: 'Total',
    contact: 'Contact',
    examination: 'Examination',
    service: 'Service',
    consultation: 'Follow up visit',
    crNumber: 'Commercial Registration:',
    taxId: 'Tax ID:'
  },
  ar: {
    somethingWentWrong: 'حدث خطأ',
    tryAgain: 'اعادة المحاولة',
    print: 'طباعة',
    invoice: 'فاتورة',
    details: 'تفاصيل الفاتورة',
    invoiceNo: 'رقم فاتورة:',
    date: 'التاريخ:',
    billTo: 'فاتورة إلى',
    description: 'الوصف',
    qty: 'الكمية',
    price: 'السعر',
    insuranceCoverage: 'تغطية التأمين',
    amount: 'صافي السعر',
    subTotal: 'المجموع الفرعي',
    discount: 'خصم',
    vat: 'VAT (14%)',
    total: 'الاجمالي',
    contact: 'بيانات التواصل',
    examination: 'كشف',
    service: 'خدمة',
    consultation: 'استشارة',
    crNumber: 'رقم السجل التجاري:',
    taxId: 'الرقم الضريبي:'
  }
};